<!--フォーム全般の処理やコンポーネントの切り替えはこちらで行う-->
<script setup>
import {ref, watch, defineProps, onMounted, onUnmounted, provide, computed, inject} from "vue";
import { useRoute, useRouter} from "vue-router";
const route = useRoute();
const router = useRouter();
import shironekoPages from '../shironeko-pages.js';
import magicianwizPages from "../magicianwiz-pages.js";

//入力情報の箱を作っておく。未入力の場合も送信画面で表示されるように
function initItemModel(item) {
    // 繰り返し項目がある入力項目(例：職業、武器)
    if ('loopCount' in item) {
        for (let i = 1; i <= item.loopCount; i++) {
            let key = item.name + i;
            if (key in inputValues.value) continue;
            inputValues.value[key] = null;
        }
        return;
    }
    // グループ項目がある入力項目(例：秘密の質問・秘密の回答)
    if ('groups' in item) {
        for (let i = 1; i <= item.currentLoopCount.value; i++) {
            for (let j = 0; j < item.groups.length; j++) {
                let groupItem = item.groups[j];
                let key = groupItem.name + i;
                if (key in inputValues.value) continue;
                inputValues.value[key] = null;
            }
        }
        return;
    }
    // 通常の入力項目
    if (!(item.name in inputValues.value)) {
        inputValues.value[item.name] = null;
    }
}

// ページ遷移で呼び出される
watch(() => route.params.id, (newId, oldId) => {
    if (!newId || newId <= 0) {
        router.push('/');
    }
    // コンポーネントが見つからない時はトップページに遷移
    if (currentPageInfo.value.component.__name === 'undefined') {
        router.push('/');
    }
    index.value = Number(newId);
    if (currentPageInfo.value.component.__name === 'FreeText') {
        for(let i = 0; i < currentPageInfo.value.items.length; i++) {
            initItemModel(currentPageInfo.value.items[i]);
        }
    }
});


const index = ref(1);

const props = defineProps({
    code: String
});
const inputValues = ref({})
const keyFirstSetOrder = ref({})

// inputValues に新しいキーが追加されたら（v-model 経由・setInputValue 経由問わず）
// keyFirstSetOrder に未登録なら現在の登録件数を順序値として記録
watch(() => Object.keys(inputValues.value).length, () => {
    for (const key of Object.keys(inputValues.value)) {
        if (!(key in keyFirstSetOrder.value)) {
            keyFirstSetOrder.value[key] = Object.keys(keyFirstSetOrder.value).length;
        }
    }
});

// タイトルによる固有の設定を読み込み
const {currentPageInfo,
    pageInfoMap,
    isGooglePlayPayInfoPage,
    BILLING_DETAIL_APPLE_HTML,
    BILLING_DETAIL_AMAZON_HTML,
    PLAY_INFO1_INDEX,
    REISSUE_MAIL_ADDRESS,
    CONTACT_MAIL_ADDRESS,
    PROJECT_NAME
} = getPageInfo();

const isClickSendMail = ref(false);
function getPageInfo () {
    switch (props.code) {
        case SHIRONEKO_PROJECT:
            return shironekoPages(inputValues, index);
        case MAGICIANWIZ:
            return magicianwizPages(inputValues, index);
    }
}
// 戻るを押した際に直前に表示していたページの入力情報を削除する
function resetInputValue(index) {
    const pageInfo = pageInfoMap[index];
    // 選択肢の場合は、入力内容が残っていると戻るボタンを押した際に戻り先がおかしくなる可能性があるので、リセットしておく
    if (pageInfo.component.__name === 'SelectForm') {
        if (pageInfo.title in inputValues.value) {
            delete inputValues.value[pageInfo.title];
        }
    }
}
// 入力情報をセットする
function setInputValue(index, key, value) {
    if (key || value) {
        inputValues.value[key] = value;
        // 初回 set のときだけ順序を記録（再 set は無視して元の順序を保持）
        if (!(key in keyFirstSetOrder.value)) {
            keyFirstSetOrder.value[key] = Object.keys(keyFirstSetOrder.value).length;
        }
    }
}

function sendMail() {
    isClickSendMail.value = true;
}

const LEAVE_PAGE_ALARM_TEXT = '保存されていないデータは破棄されます。';
onMounted(() => {
    // ページリロード等で離れる場合にアラートが表示されるようにする(mobileのsafariは非対応)
    window.onbeforeunload = function (event) {
        // メーラーを開いた際にもアラートが表示されるのを防ぐ
        if (!isClickSendMail.value) {
            return LEAVE_PAGE_ALARM_TEXT;
        }
        isClickSendMail.value = false;
    }
    router.push('/form/1');
})
onUnmounted((() => {
    window.onbeforeunload = null
}))

const getPreviousIndex = computed(() => {
    if (!currentPageInfo.value.previousIndex) {
        return index.value - 1;
    }
    if (!isNaN(currentPageInfo.value.previousIndex)) {
        return currentPageInfo.value.previousIndex;
    }
    return currentPageInfo.value.previousIndex.value;
});
// 進むを押した際の次のページのindexを取得
const getNextIndex = computed(() => {
    if (!currentPageInfo.value.nextIndex) {
        return index + 1;
    }
    // 次のページが固定値の場合
    if (!isNaN(currentPageInfo.value.nextIndex)) {
        return currentPageInfo.value.nextIndex;
    }
    // 次のページが選択によって変わる場合はリアクティブ
    return currentPageInfo.value.nextIndex.value;
});

const SHIRONEKO_PROJECT = 'shironekoproject';
const MAGICIANWIZ = 'magicianwiz';

// 動的コンポーネントで使用する定数や値を定義
provide('PLAY_INFO1_INDEX', PLAY_INFO1_INDEX);
provide('BILLING_DETAIL_APPLE_HTML', BILLING_DETAIL_APPLE_HTML);
provide('BILLING_DETAIL_AMAZON_HTML', BILLING_DETAIL_AMAZON_HTML);
provide('REISSUE_MAIL_ADDRESS', REISSUE_MAIL_ADDRESS);
provide('CONTACT_MAIL_ADDRESS', CONTACT_MAIL_ADDRESS);
provide('PROJECT_NAME', PROJECT_NAME);
provide('code', props.code);
provide('index', index);

</script>

<template>
    <component
        @changeIndex="setInputValue"
        @resetInputValue="resetInputValue"
        @sendMail="sendMail"
        :is="currentPageInfo.component"
        :message="currentPageInfo.message"
        :itemPurchaseDetails="currentPageInfo.itemPurchaseDetails"
        :title="currentPageInfo.title"
        :image="currentPageInfo.image"
        :selections="currentPageInfo.selections"
        :items="currentPageInfo.items"
        :input-values="inputValues"
        :key-first-set-order="keyFirstSetOrder"
        :direction="'direction' in currentPageInfo ? currentPageInfo.direction : null"
        :next-index="getNextIndex"
        :previous-index="getPreviousIndex"
        :show-confirm="'showConfirm' in currentPageInfo ? currentPageInfo.showConfirm : true"
        :show-apple-billing-detail-guide="'showAppleBillingDetailGuide' in currentPageInfo ? currentPageInfo.showAppleBillingDetailGuide : true"
        :is-top-return="'isTopReturn' in currentPageInfo ? currentPageInfo.isTopReturn : false"
        :is-google-play-pay-info-page="isGooglePlayPayInfoPage"
        :pay-info-link-html="currentPageInfo.payInfoLinkHtml || ''"
        :is-record-answer="'isRecordAnswer' in currentPageInfo ? currentPageInfo.isRecordAnswer : true"
    />
</template>

<style scoped>
</style>